<template>
    <vue-modaltor :visible="open"
                  @hide="hideModal"
                  :default-width="'600px'"
                  :resize-width='{ 1200:"550px",992:"550px",768:"100%" }'
                  :animation-panel="'modal-slide-top'"
    >
        <template slot="close-icon">
            <i class="fas fa-times"></i>
        </template>
        <div v-if="open" class="cart-content">
            <h4>{{ textHeading }}</h4>

            <img :src="cartItem.attributes.product_preview"
                 :alt="cartItem.name"
            >

            <p class="out-of-stock" v-if="cartQuantity > stockQuantity">
                {{ outOfStock }}
            </p>

            <div class="cart-content-actions">
                <a href="#" @click="hideModal" class="button success">
                    {{ textContinueShopping }}
                </a>
                <a :href="routeToCart" class="button">
                    {{ textGoToCart }}
                </a>
            </div>
        </div>
    </vue-modaltor>
</template>

<script>

    export default {
        props: {
          textHeading: {
              required: true,
              type: String
          },
          textContinueShopping: {
              required: true,
              type: String
          },
          textGoToCart: {
              required: true,
              type: String,
          },
          routeToCart: {
              required: true,
              type: String
          },
          outOfStock: {
              required: true,
              type: String
          }
        },

        data() {
            return {
                open: false,
                cartItem: {},
            }
        },

        mounted() {
            this.$root.$on('renderPopupProductAdded', data => {
                this.cartItem = data.cartItem;
                this.stockQuantity = data.stockQuantity;
                this.cartQuantity = data.cartQuantity;

                this.open = true;
            });
        },

        methods: {
            hideModal() {
                this.open = false;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .cart-content {
        text-align: center;
        img {
            margin-top: 25px;
            max-width: 60%;
        }
        p {
            color: #ff0000;
        }   
        &-actions {
            margin-top: 25px;
            display: flex;
            align-content: center;
            align-items: center;
            justify-content: space-around;

            .button {
                padding: 0 35px !important;

                &:last-child {
                    height: 45px !important;
                }
            }

            @media ( max-width: 768px ) {

                .button:first-child {
                    margin-right: 10px;
                }
            }
        }
    }
</style>
